// Dia local del navegador en YYYY-MM-DD. NUNCA usar toISOString() para "hoy"
// ni para el valor de un date-picker: convierte a UTC y despues de las 21:00
// (Argentina, UTC-3) devuelve el dia siguiente — y un Date de medianoche local
// devuelve SIEMPRE el dia anterior.
export const toYMD = (d: Date): string =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

export const hoyLocal = (): string => toYMD(new Date());
